export default __webpack_public_path__ + "static/media/login_bg3.9302a5ed.png";